<div class="container contracts-container mt-5 pb-4">
    <div class="row justify-content-center">
        <div class="col-md-12 col-sm-12 col-10 container-contratos">
            <h2 class="text-center mb-4 mt-md-3">CONTRATOS VIGENTES</h2>
            <div class="table-responsive-container position-relative">
                <div class="table-responsive mb-5"> 
                    <table class="table table-borderless table-hover" *ngIf="dataContracts && dataContracts.length > 0">
                        <tbody>
                        <tr *ngFor="let dataContract of dataContracts | paginate: paginatorConfig">
                            <td class="text-center font-weight-bold link-contrats" scope="row" [routerLink]="'/contratos/' + dataContract.codContrato">Nº Contrato {{ dataContract.numeroContrato }}</td>
                            <td style="color:#67170F !important" class="text-center link-contrats contract-description" [routerLink]="'/contratos/' + dataContract.codContrato">{{ dataContract.descripcionCorta | slice:0:10}} ...</td>
                            <td class="text-center link-contrats" [routerLink]="'/contratos/' + dataContract.codContrato">Vencimiento {{ dataContract.fechaVencimiento | date: "dd/MM/yyyy" }}</td>
                            <td class="text-center link-contrats" [routerLink]="'/contratos/' + dataContract.codContrato">Renovaciones: {{ dataContract.numRenovaciones }}</td>
                            <td class="text-center link-contrats" [routerLink]="'/contratos/' + dataContract.codContrato">
                                <!-- (click)="requestContractRenewal(dataContract.codContrato)" -->
                                <button class="btn btn-small btn-primary btn-detail-contract" >  
                                     DETALLE <fa-icon [icon]="faSyncAlt"></fa-icon>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <app-loader *ngIf="(showLoader || !dataContracts) && errormessage === ''"></app-loader>
                    <div *ngIf="errormessage" class="text-center">
                        {{ errormessage }}
                    </div>
                </div>
              
            </div>
            <app-custom-paginator *ngIf="dataContracts && dataContracts.length != 0" [elementsArray]="dataContracts"
                                  [paginationConfig]="paginatorConfig"></app-custom-paginator>
        </div>
    </div>
</div>
<app-modal [attr.id]="modalId" [modalId]="modalId" class="d-none">
    <div
        class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-12 offset-0 text-center message-container my-5">
        <p>{{textMessage}}</p>
    </div>
</app-modal>
<app-historic-contracts></app-historic-contracts>
